// public/v3/src/components/program-filter-toggle.jsx — chrome-level
// All/CCM/BHI/Nav/Pain segmented control. Lets the operator flip between program
// views (Time Logs, Studio, Onboard) when a concurrent program is enabled.
//
// Renders nothing when no concurrent program is enabled so the chrome stays
// untouched for CCM-only practices. Segments render per enabled program
// (bhiEnabled → BHI, pinEnabled → Nav, painEnabled → Pain). Optional ccmCount/bhiCount render
// as small badges next to each segment label.

import React from 'react';

export function ProgramFilterToggle({ value, onChange, bhiEnabled, pinEnabled, painEnabled, ccmCount, bhiCount }) {
  if (!bhiEnabled && !painEnabled && !pinEnabled) return null;
  return (
    <div className="program-filter-toggle" role="group" aria-label="Program filter">
      <button
        type="button"
        className={`pft-segment pft-all ${value === 'all' ? 'active' : ''}`}
        onClick={() => onChange('all')}
        aria-pressed={value === 'all'}
      >
        All
      </button>
      <button
        type="button"
        className={`pft-segment pft-ccm ${value === 'ccm' ? 'active' : ''}`}
        onClick={() => onChange('ccm')}
        aria-pressed={value === 'ccm'}
      >
        CCM{ccmCount != null && <span className="pft-count"> {ccmCount}</span>}
      </button>
      {bhiEnabled && (
        <button
          type="button"
          className={`pft-segment pft-bhi ${value === 'bhi' ? 'active' : ''}`}
          onClick={() => onChange('bhi')}
          aria-pressed={value === 'bhi'}
        >
          BHI{bhiCount != null && <span className="pft-count"> {bhiCount}</span>}
        </button>
      )}
      {pinEnabled && (
        <button
          type="button"
          className={`pft-segment pft-pin ${value === 'pin' ? 'active' : ''}`}
          onClick={() => onChange('pin')}
          aria-pressed={value === 'pin'}
        >
          Nav
        </button>
      )}
      {painEnabled && (
        <button
          type="button"
          className={`pft-segment pft-pain ${value === 'pain' ? 'active' : ''}`}
          onClick={() => onChange('pain')}
          aria-pressed={value === 'pain'}
        >
          Pain
        </button>
      )}
    </div>
  );
}
